import { makeStyles } from "@material-ui/core/styles";

export const getGridCardStyles = makeStyles(theme => ({
  cardContent: {
    padding: 0,
    marginTop: 8,
    '&:last-child': {
      padding: 0,
    },
    '& .pagination-bar': {
      border: 0,
      borderTop: `1px solid ${theme.palette.divider}`,
    }
  },
}));
